import { render, staticRenderFns } from "./PopCorn.vue?vue&type=template&id=a5f39a62&scoped=true"
import script from "./PopCorn.vue?vue&type=script&lang=js"
export * from "./PopCorn.vue?vue&type=script&lang=js"
import style0 from "./PopCorn.vue?vue&type=style&index=0&id=a5f39a62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f39a62",
  null
  
)

export default component.exports